import './HeroBlobs.css';

export default function HeroBlobs() {
    return (
        <svg
            className="hero-blob-scene"
            viewBox="0 0 900 600"
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <g transform="translate(900, 0)">
                <path
                    className="hero-blob hero-blob-1"
                    d="M0 432.7C-33.6 433.1 -67.1 433.5 -96.3 421.8C-125.4 410.1 -150.1 386.3 -179.2 372.1C-208.3 357.9 -241.8 353.3 -266.2 333.8C-290.6 314.4 -306 280.1 -308 245.7C-310.1 211.2 -299 176.6 -318 153.2C-337.1 129.7 -386.3 117.4 -410.4 93.7C-434.6 70 -433.6 35 -432.7 0L0 0Z"
                    fill="var(--navy-accent)"
                />
                <path
                    className="hero-blob hero-blob-2"
                    d="M0 288.4C-22.4 288.7 -44.8 289 -64.2 281.2C-83.6 273.4 -100.1 257.5 -119.5 248.1C-138.9 238.6 -161.2 235.5 -177.5 222.6C-193.8 209.6 -204 186.7 -205.4 163.8C-206.8 140.8 -199.3 117.8 -212 102.1C-224.7 86.5 -257.5 78.2 -273.6 62.5C-289.7 46.7 -289.1 23.3 -288.4 0L0 0Z"
                    fill="var(--purple-accent)"
                />
                <path
                    className="hero-blob hero-blob-3"
                    d="M0 144.2C-11.2 144.4 -22.4 144.5 -32.1 140.6C-41.8 136.7 -50 128.8 -59.7 124C-69.4 119.3 -80.6 117.8 -88.7 111.3C-96.9 104.8 -102 93.4 -102.7 81.9C-103.4 70.4 -99.7 58.9 -106 51.1C-112.4 43.2 -128.8 39.1 -136.8 31.2C-144.9 23.3 -144.5 11.7 -144.2 0L0 0Z"
                    fill="var(--pink-accent)"
                />
            </g>
            <g transform="translate(0, 600)">
                <path
                    className="hero-blob hero-blob-4"
                    d="M0 -432.7C34.6 -436.8 69.1 -441 96.3 -421.8C123.4 -402.7 143.2 -360.2 158.4 -328.9C173.6 -297.5 184.2 -277.4 217.6 -272.9C251 -268.4 307.3 -279.5 327.6 -261.2C347.9 -243 332.3 -195.3 338.8 -163.1C345.2 -131 373.6 -114.3 392.9 -89.7C412.2 -65.1 422.4 -32.5 432.7 0L0 0Z"
                    fill="var(--navy-accent)"
                />
                <path
                    className="hero-blob hero-blob-5"
                    d="M0 -288.4C23 -291.2 46.1 -294 64.2 -281.2C82.3 -268.4 95.5 -240.1 105.6 -219.2C115.7 -198.4 122.8 -184.9 145.1 -181.9C167.3 -178.9 204.8 -186.3 218.4 -174.2C231.9 -162 221.6 -130.2 225.8 -108.8C230.1 -87.3 249.1 -76.2 261.9 -59.8C274.8 -43.4 281.6 -21.7 288.4 0L0 0Z"
                    fill="var(--purple-accent)"
                />
                <path
                    className="hero-blob hero-blob-6"
                    d="M0 -144.2C11.5 -145.6 23 -147 32.1 -140.6C41.1 -134.2 47.7 -120.1 52.8 -109.6C57.9 -99.2 61.4 -92.5 72.5 -91C83.7 -89.5 102.4 -93.2 109.2 -87.1C116 -81 110.8 -65.1 112.9 -54.4C115.1 -43.7 124.5 -38.1 131 -29.9C137.4 -21.7 140.8 -10.8 144.2 0L0 0Z"
                    fill="var(--pink-accent)"
                />
            </g>
        </svg>
    );
}
